<template>
  <div class="wechat-login-container">
    <div v-if="!showSuccess" class="qrcode-wrapper">
      <div id="wx-qrcode" style="width:300px;height:340px;"></div>

      <div class="tips" v-if="!fastLogin">
        <p v-if="expireTime > 0">{{ $t("login.periodOfCode") }}{{ expireTime }} S</p>
        <p v-else>
          {{ $t("login.codeOutOfDate") }}
          <a href="javascript:;" @click="initWechatLogin">{{ $t("login.refreshCode") }}</a>
        </p>
      </div>
    </div>

    <div v-else class="login-success">
      <i class="el-icon-success"></i>
      <p>{{ $t("login.loginSuccess") }}</p>
      <p>{{ $t("login.redirecting") }}</p>
    </div>
  </div>
</template>

<script>


export default {
  name: "WechatLogin",
  props:{
    redirectUri:{
      type: String,
      default: 'https://ywtb.cqtc.edu.cn/wechatCallback',
    }
  },
  data() {
    return {
      expireTime: 300, // 二维码有效期5分钟（微信默认）
      showSuccess: false,
      wxLoginInstance: null,
      fastLogin: 1,
    };
  },
  mounted() {
    this.initWechatLogin();
  },
  beforeDestroy() {
    if (this.wxLoginInstance) {
      // 清理微信登录实例
      document.getElementById('wx-qrcode').innerHTML = '';
    }
  },
  methods: {
    // 初始化微信登录
    initWechatLogin() {
      const appId = this.getAppId();
      if (!appId || !/^wx[a-z\d]+$/i.test(appId)) {
        console.error('微信AppId未配置');
        return;
      }

      // 清理旧的实例
      if (this.wxLoginInstance) {
        document.getElementById('wx-qrcode').innerHTML = '';
      }

      // 动态加载微信官方JS
      if (!window.WxLogin) {
        const script = document.createElement('script');
        script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
        script.onload = () => this.initWxLogin(appId);
        document.body.appendChild(script);
      } else {
        this.initWxLogin(appId);
      }

      if(!this.fastLogin){
        this.startCountdown();
      }
    },

    initWxLogin(appId) {
      const cssText = `
              .impowerBox .loginPanel.normalPanel  .title,
              .impowerBox .title_wrp{
                  display:none !important;
              }
              .impowerBox .qrcode{
                  margin-top:0px !important;
              }
            `
      const cssBase64 = window.btoa(unescape(encodeURIComponent(cssText)))

      console.log('cssBase64cssBase64cssBase64cssBase64')
      this.wxLoginInstance = new window.WxLogin({
        id: 'wx-qrcode',
        appid: appId,
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent(this.redirectUri),
        state: 'state_' + Date.now(),
        self_redirect: false,
        style: "black",
        href:'data:text/css;base64,'+ cssBase64,
        //快速登录，比如PC上登录了微信，可以直接使用PC微信登录，0为关闭此功能
        fast_login: this.fastLogin
      });
    },

    // 开始倒计时
    startCountdown() {
      this.expireTime = 300; // 重置为5分钟
      const timer = setInterval(() => {
        this.expireTime--;
        if (this.expireTime <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },

    getAppId() {
      const allData = JSON.parse(localStorage.getItem("allConfig")) || [];
      return allData.find(item => item.key === "wx.open.appid")?.value;
    },

    // 登录成功处理（由微信回调页面处理，这里只是示例）
    handleLoginSuccess(userInfo) {
      this.showSuccess = true;
      this.$store.commit("SET_USER_INFO", userInfo);
      setTimeout(() => {
        const redirect = this.$route.query.redirect || "/";
        this.$router.replace(redirect);
      }, 1500);
    }
  }
};
</script>

<style scoped lang="scss">
/* 保持原有样式不变 */
.wechat-login-container {
  text-align: center;
  padding: 0px;
}

.qrcode-wrapper {
  margin: 0 auto;
  width: 300px;
}

.tips {
  color: #666;
  font-size: 14px;
}

.tips a {
  color: #409eff;
}

.login-success {
  color: #67c23a;
  font-size: 16px;
}

.el-icon-success {
  font-size: 60px;
  margin-bottom: 15px;
}
</style>
